export default function ValidateRegisterUser(form, noPLnumber) {
  let error = {};

  if (!form.name) {
    error.name = "Proszę wpisać swoje imię.";
  } else if (form.name.length < 3) {
    error.name = "Proszę wpisać poprawne imię.";
  }

  if (!form.last_name) {
    error.last_name = "Proszę wpisać swoje nazwisko.";
  } else if (form.last_name.length < 3) {
    error.last_name = "Proszę wpisać poprawne nazwisko.";
  }

  if (!noPLnumber && !form.phone) {
    error.phone = "Proszę wpisać swój numer telefonu.";
  } else if (!noPLnumber && !/(^|\W)(\(?(\+|00)?48\)?)?[ -]?\d{3}[ -]?\d{3}[ -]?\d{3}(?!\w)/g.test(form.phone)) {
    error.phone = "Proszę wpisać poprawny numer telefonu.";
  }

  if (noPLnumber && !form.email) {
    error.email = "Proszę wpisać swój adres e-mail.";
  } else if (noPLnumber && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(form.email)) {
    error.email = "Proszę wpisać poprawny adres e-mail.";
  }

  if (!form.password) {
    error.password = "Proszę ustalić swoje hasło.";
  } else if (form.password.length < 6) {
    error.password = "Proszę ustalić dłuższe hasło.";
  }

  if (!form.passwordRep) {
    error.passwordRep = "Proszę powtórzyć swoje hasło.";
  } else if (form.passwordRep !== form.password) {
    error.passwordRep = "Podane hasła nie są takie same.";
  }

  return error;
};